import { useStores } from 'hooks';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { RED, WHITE } from '../../Styles';
import { StyledButton } from '../Styles';

export const DisableLoggingButton = observer(() => {
  const {
    DebuggerStore: { handleDisableLogging },
  } = useStores();

  return (
    <StyledButton
      bgColor={RED}
      color={WHITE}
      onClick={handleDisableLogging}
      style={{ cursor: 'pointer' }}
    >
      Disable/Delete Logs
    </StyledButton>
  );
});

export default DisableLoggingButton;
